import PropTypes from 'prop-types';
import { Component, Suspense } from 'react';
import { lazyWithRetries } from 'src/routes/lazyRetry';

// The one way every entry point opens the call review. The review is loaded when first opened
// (it is large and most pages never need it), with retries after a deploy, and inside its own
// boundary: if it still can't load (or throws), it closes rather than blank the page behind
// it. This matters most for the call pill, which sits directly under the app-wide boundary.
const CallReview = lazyWithRetries(() => import('./CallReview'));

class ReviewBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    this.props.onFail?.();
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
ReviewBoundary.propTypes = { onFail: PropTypes.func, children: PropTypes.node };
ReviewBoundary.defaultProps = { onFail: undefined, children: null };

export default function LazyCallReview(props) {
  return (
    <ReviewBoundary onFail={props.onClose}>
      <Suspense fallback={null}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <CallReview {...props} />
      </Suspense>
    </ReviewBoundary>
  );
}

LazyCallReview.propTypes = { callId: PropTypes.string.isRequired, onClose: PropTypes.func.isRequired };
